import React, { Component } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import LoginPage from "./components/Login";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import Logo from "./assets/images/logo.png";
import Cookies from "js-cookie";
import { getUserFromJWT } from "./utils/jwt.decode";
import { ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/navbar.css";
import "./css/main.css";
import ViberBulk from "./components/ViberBulk";
import UsersList from "./components/Clients";
import Messages from "./components/Messages";
import ChatBox from "./components/ChatBox";
import Admins from "./components/Admins";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentUser: null,
      isLoggedIn: false,
    };
    this.reRender = this.reRender.bind(this);
    this.handleLogOut = this.handleLogOut.bind(this);
  }

  componentDidMount() {
    const user = getUserFromJWT();
    if (user) {
      this.setState({
        currentUser: {
          userName: user.userName,
          userId: user.userId,
          isSuperAdmin: user.isSuperAdmin,
          role: user.role,
        },
        isLoggedIn: true,
      });
      Cookies.set("currentUser", user.userName);
      Cookies.set("isSuperAdmin", user.isSuperAdmin);
      Cookies.set("role", user.role);
    }
  }

  handleLogOut() {
    Cookies.remove("jwt");
    Cookies.remove("currentUser");
    Cookies.remove("isSuperAdmin");
    Cookies.remove("role");
    this.setState({ currentUser: null, isLoggedIn: false });
    window.location.replace("/");
  }

  reRender() {
    this.forceUpdate();
    const user = getUserFromJWT();
    if (user)
      this.setState({
        currentUser: {
          userName: user.userName,
          userId: user.userId,
          isSuperAdmin: user.isSuperAdmin,
          role: user.role,
        },
        isLoggedIn: true,
      });
  }

  render() {
    if (this.state.isLoggedIn) {
      return (
        <Router>
          <ToastContainer />
          <Navbar
            sticky="top"
            expand="lg"
            variant="light"
            className="main-navigation myNavbar"
          >
            <Navbar.Brand>
              <Link to="/" className="navbar-brand">
                <img src={Logo} alt="" />
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" className="myNav">
              <Nav className="mr-auto">
                <Link to="/clients" className="nav-link-item">
                  Корисници
                </Link>
              </Nav>
              <Nav className="mr-auto">
                <Link to="/messages" className="nav-link-item">
                  Разговори
                </Link>
              </Nav>
              {this.state.currentUser && this.state.currentUser.isSuperAdmin ?
                <Nav className="mr-auto">
                  <Link to="/admins" className="nav-link-item">
                    Администратори
                  </Link>
                </Nav>
                : null}
              {this.state.currentUser ?
                <Nav className="mr-auto">
                  <Link to="/" className="nav-link-item">
                    Вибер Булк
                  </Link>
                </Nav>
                : null}
              <Nav className="mr-auto">
                <NavDropdown
                  title={Cookies.get("currentUser")}
                  id="basic-nav-dropdown"
                  className="nav-link-item myNavDropdown"
                >
                  <NavDropdown.Item
                    onClick={this.handleLogOut}
                    className="nav-ling-item"
                  >
                    Одјави се
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
  
      <div fluid className="px-3">
          <Routes>
            <Route path="/" element={<ViberBulk />} />
            <Route path="/clients" element={<UsersList />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/messages/:conversationId" element={<ChatBox />} />
            <Route path="/admins" element={<Admins />} />
          </Routes>
       </div>
  </Router>
      );
    } else {
      return <LoginPage afterLogin={this.reRender} />;
    }
  }
}

export default App;
